import { DepartmentCsvRowError } from '@/interfaces/model/general/department';

/**
 * 行エラーを「29行目: 部署名: 理由」の形にまとめる。
 *
 * 行番号が無いと、利用者は Excel 上でどこを直せばよいか分からない。
 * 部署名が空の行 (階層列が全部空など) もあるので、空の要素は落として繋ぐ。
 *
 * 行ラベルの文言はロケールごとに違うため、組み立て済みの文字列を渡してもらう
 * (util から i18n を触ると、テストのたびに i18n の初期化が要る)。
 */
export const formatDepartmentCsvRowError = (
  err: DepartmentCsvRowError,
  rowLabel: (row: number) => string
): string => {
  const prefix = err.row ? rowLabel(err.row) : '';
  const label = [prefix, err.department].filter(Boolean).join(': ');
  return label ? `${label}: ${err.error}` : err.error;
};
